import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=9f704798&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sebastian/Projekte/CD-Systeme/nextgenkonfi/konfiguratornextgen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f704798')) {
      api.createRecord('9f704798', component.options)
    } else {
      api.reload('9f704798', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=9f704798&", function () {
      api.rerender('9f704798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/Sidebar.vue"
export default component.exports